import React from 'react'
import styles from './styles.css'
import moment from 'moment'
import OkIcon from 'react-icons/lib/md/done-all'

export default function Message(props) {
  const {message, isRead, sending} = props
  const isFromAdmin = !!message.sentByAdminId
  let className = styles.container

  if (isFromAdmin) {
    className = styles.admin
  }

  if (sending) {
    className = styles.sending
  }

  const renderMessage = () => {
    const {text, image} = message
    if (text)
      return (
        <div className={styles.text} onClick={ev => ev.stopPropagation()}>
          {text}
        </div>
      )

    if (image)
      return (
        <div
          className={image.isSending ? styles.sendingImageContainer : styles.imageContainer}
          onClick={image ? () => window.open(image.url) : null}>
          <img src={image.url} className={styles.image} alt={`Image with id: ${image._id}`} />
        </div>
      )
  }

  return (
    <div className={className}>
      <div className={styles.date}>
        {isRead && isFromAdmin ? <OkIcon /> : null}{' '}
        {message.senderName ? message.senderName : 'Enviando'}
        {' - '}
        {moment(message.date).format('LLL')}
      </div>
      {renderMessage()}
    </div>
  )
}
